import { render } from "./YearView.vue?vue&type=template&id=0c0dd953"
import script from "./YearView.vue?vue&type=script&lang=js"
export * from "./YearView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__